import './styles.css';
import { GameApp } from './ui/GameApp';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('Application root not found.');

new GameApp(root);
